import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 12\" id=\"icon-check\"><path fill=\"#28A745\" fill-rule=\"evenodd\" d=\"M10.253 2.724c.153.14.163.377.023.53l-5.5 6a.375.375 0 0 1-.541.011l-2.5-2.5a.375.375 0 0 1 .53-.53l2.223 2.223 5.236-5.711a.375.375 0 0 1 .53-.023\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol